import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/views/login/Login'
import ResetPassword from '@/views/login/ResetPassword'
import ValidateEmail from '@/views/login/validateEmail'
import Registration from '@/views/hanscourse/warranty/Warranty'
import warrantyView from '@/views/hanscourse/warranty/warrantyView'

import Main from '@/views/hanscourse/Main'

Vue.use(Router)

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// 针对 push 方法
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 针对 replace 方法
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component:Login,
    // },
     // 优惠活动页面
     {
      path: '/promotions',
      name: 'Promotions',
      component: resolve =>
          require(['@/views/promotions/index'],resolve),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/payments',
      name: 'Payments',
      component: resolve =>
          require(['@/views/payments/index'],resolve),
      meta: {
        requireAuth: false
      },
    },
    {
      path: '/callback',
      name: 'Callback',
      component: resolve =>
          require(['@/views/hanscourse/shoppingcenter/paycallback'],resolve),
      meta: {
        requireAuth: false
      },
    },
    {
        path: '/promotion',
        name: 'Promotion',
        component: resolve =>
            require(['@/views/promotions/promotion'],resolve),
        meta: {
            requireAuth: true
        }
    },
    
    {
      path: '/detail',
      name: 'detail',
      component: resolve =>
          require(['@/views/promotions/detail'],resolve),
      meta: {
          requireAuth: false
      }
    },
    {
      path: '/resetpwd',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/validateEmail',
      name: 'validateEmail',
      component: ValidateEmail, 
    },
    // asp注册页面
    {
      path: '/product_register.asp',
      name: 'productRegister',
      component: resolve =>
          require(['@/views/login/registasp'],resolve),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/warrantyView',
      name: 'warrantyView',
      component: warrantyView
    },
    {
      path:'/',
      name: 'Main',
      component: Main,
      children:[
        {
          path: '/index',
          name: 'mainpage',
          component: resolve =>
              require(['@/views/hanscourse/mainpage/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/accountcenter',
          name: 'AccountCenter',
          component: resolve =>
              require(['@/views/hanscourse/accountcenter/index'],resolve),
          meta: {
              requireAuth: true
          }
        },
        {
          path: '/reg',
          name: 'reg',
          component: Registration
        },
        // 独立的订单查询页面
        {
          path: '/orders',
          name: 'OrderQuery',
          component: resolve =>
              require(['@/views/orders/orderquery'],resolve),
          meta: {
              requireAuth: true
          }
        },
        {
          path: '/pointshop',
          name: 'pointshop',
          component: resolve =>
              require(['@/views/hanscourse/pointshop/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/pointshop/gooddetail',
          name: 'gooddetail',
          component: resolve =>
              require(['@/views/hanscourse/pointshop/gooddetail'],resolve),
          meta: {
              parent: 'pointshop',
              requireAuth: false
          }
        },

        {
          path: '/gamecenter',
          name: 'gamecenter',
          component: resolve =>
              require(['@/views/hanscourse/gamecenter'],resolve),
          meta: {
              requireAuth: false
          }
        },

        {
          path: '/shoppingcenter',
          name: 'shoppingcenter',
          component: resolve =>
              require(['@/views/hanscourse/shoppingcenter'],resolve),
          meta: {
              requireAuth: false
          }
        },
        // 商品详情
        {
          path: '/productdetail',
          name: 'productdetail',
          component: resolve =>
              require(['@/views/hanscourse/shoppingcenter/product_detail'],resolve),
          meta: {

            parent: 'shoppingcenter',
            requireAuth: false
          }
        },

        // 购物车结算
        {
          path: '/shoppingcar',
          name: 'shoppingcar',
          component: resolve =>
              require(['@/views/hanscourse/shoppingcenter/shopping_car'],resolve),
          meta: {

            parent: 'shoppingcenter',
            requireAuth: false
          }
        },

        // 下订单界面
        {
          path: '/placeorder',
          name: 'placeorder',
          component: resolve =>
              require(['@/views/hanscourse/shoppingcenter/place_order'],resolve),
          meta: {

            parent: 'shoppingcenter',
            requireAuth: false
          }
        },
         // 付款二维码界面
         {
          path: '/pay',
          name: 'orderdetail',
          component: resolve =>
              require(['@/views/hanscourse/accountcenter/order_detail'],resolve),
          meta: {

            parent: 'shoppingcenter',
            requireAuth: false
          }
        },
        {
          path: '/about',
          name: 'about',
          component: resolve =>
              require(['@/views/hanscourse/about/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/activity',
          name: 'activity',
          component: resolve =>
              require(['@/views/hanscourse/activity/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/contactus',
          name: 'contactUs',
          component: resolve =>
              require(['@/views/hanscourse/contactus/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/faq',
          name: 'faq',
          component: resolve =>
              require(['@/views/hanscourse/faq/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/freetrial',
          name: 'freetrial',
          component: resolve =>
              require(['@/views/hanscourse/freetrial/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/learnstar',
          name: 'learnstar',
          component: resolve =>
              require(['@/views/hanscourse/learnstar/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/typingmain',
          name: 'typingmain',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/typingmain/wating',
          name: 'Wating',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/wating'],resolve),
          meta: {
              requireAuth: true,
          }
        },
        {
          path: '/typingmain/typinggame',
          name: 'TypingGame',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/game'],resolve),
          meta: {
              parent: 'typingmain',
              requireAuth: true,
          }
        },
        {
          path: '/typingmain/gameresult',
          name: 'TypingGameResult',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/typinggame_result'],resolve),
          meta: {
              parent: 'typingmain',
              requireAuth: true,
          }
        },
        {
          path: '/typingmain/gameanalysis',
          name: 'Gameanalysis',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/gameanalysis'],resolve),
          meta: {
              parent: 'typingmain',
              requireAuth: true,
          }
        },
        {
          path: '/typingmain/practicepage',
          name: 'PracticePage',
          component: resolve =>
              require(['@/views/hanscourse/typinggame/practicepage'],resolve),
          meta: {
              parent: 'typingmain',
              requireAuth: true,
          }
        },
        
        {
          path: '/dictionarymain',
          name: 'dictionarymain',
          component: resolve =>
              require(['@/views/hanscourse/dictionarymatch/index'],resolve),
          meta: {
              requireAuth: false
          }
        },
        {
          path: '/dictionarymain/game',
          name: 'DictionaryGame',
          component: resolve =>
              require(['@/views/hanscourse/dictionarymatch/game'],resolve),
          meta: {
              parent: 'dictionarymain',
              requireAuth: true,
          }
        },
        {
          path: '/dictionarymain/gameresult',
          name: 'DictionaryGameResult',
          component: resolve =>
              require(['@/views/hanscourse/dictionarymatch/game_result'],resolve),
          meta: {
              parent: 'dictionarymain',
              requireAuth: true,
          }
        },
        // 游戏中心
        {
          path: '/gamecenter/race',
          name: 'Race',
          component: resolve =>
              require(['@/views/hanscourse/gamecenter/race'],resolve),
          meta: {
            parent: 'gamecenter',
            requireAuth: true
          }
        },
        {
          path: '/gamecenter/plane',
          name: 'Plane',
          component: resolve =>
              require(['@/views/hanscourse/gamecenter/plane'],resolve),
          meta: {
            parent: 'gamecenter',
            requireAuth: true
          }
        },
        {
          path: '/gamecenter/bee',
          name: 'Bee',
          component: resolve =>
              require(['@/views/hanscourse/gamecenter/bee'],resolve),
          meta: {
            parent: 'gamecenter',
            requireAuth: true
          }
        },
        
      ]
    }
  ],
  mode: 'history',
  // scrollBehavior: () => {
  //  history.pushState(null, null, document.URL)
  // }
})



// WEBPACK FOOTER //
// ./src/router/index.js